import {
  UI_COLOR_BADGE_SPECIAL_BG,
  UI_COLOR_BADGE_SPECIAL_TEXT,
  UI_COLOR_BLACK,
  UI_COLOR_BORDER_PERMISSION,
  UI_COLOR_BORDER_PERMISSION_ALT,
  UI_COLOR_BORDER_PERMISSION_ROW,
  UI_COLOR_BORDER_SURVEY_INPUT,
  UI_COLOR_BORDER_WIZARD_FIELD,
  UI_COLOR_BORDER_WIZARD_FIELD_HOVER,
  UI_COLOR_ICON_GRAY,
  UI_COLOR_ICON_HELP,
  UI_COLOR_ICON_HELP_ACCENT,
  UI_COLOR_SHADOW_PERMISSION_CONTROL,
  UI_COLOR_STEPPER_LABEL,
  UI_COLOR_STEPPER_MUTED,
  UI_COLOR_SURFACE_PERMISSION_SOFT,
  UI_COLOR_TEXT_CANCEL,
  UI_COLOR_TEXT_MUTED_LIGHT,
  UI_COLOR_TEXT_PERMISSION_TITLE,
  UI_COLOR_TEXT_PRESET,
  UI_COLOR_TEXT_WIZARD_FIELD,
  UI_COLOR_TEXT_WIZARD_HINT,
  UI_COLOR_TEXT_WIZARD_PLACEHOLDER,
  UI_COLOR_WHITE,
  UI_COLOR_WIZARD_ERROR
} from '../../../constants/uiColors'

export const WIZARD_STEPS = ['Datos generales', 'Permisos por módulo']

export const SCOPE_LABEL_OVERRIDES = {
  'planifica|users_app': 'Usuarios app',
  'planifica|users.show.refund_limits_tab': 'Máximo de devoluciones',
  'ejecuta|poc_orders': 'Órdenes de compra',
  'ejecuta|refunds': 'Devoluciones',
  'ejecuta|refunds.show.refund_approval_rejected': 'Aprobador de devoluciones',
  'ejecuta|refunds.show.refund_process_code_erp': 'Registrar NCR',
  'ejecuta|on_board_sales': 'Venta a bordo',
  'ejecuta|charges': 'Cobros',
  'ejecuta|pos_effectiveness': 'Efectividad PDV',
  'ejecuta|reports_asset': 'Activos',
  'ejecuta|close_asset': 'Cierre de activos',
  'ejecuta|settlements.show.approval_tab': 'Aprobación de liquidaciones',
  'mide|poc_fill_rate': 'Fill Rate por cadena',
  'mide|reports.user_summary.timestamp_tab': 'Control de horario',
  'mide|pos_analysis_download': 'Descarga de reportes',
  'planifica|rbac.users': 'Usuarios Torre',
  'planifica|rbac.roles': 'Roles y permisos'
}

export const SCOPE_DESCRIPTIONS = {
  'planifica|clients':
    'Listado, crear clientes, detalles, descargar reporte de actividades, e historial.',
  'planifica|clients_applications':
    'Gestiona las solicitudes de cliente nuevo y su seguimiento.',
  'planifica|products':
    'Listado, detalles, crear productos, listas de precio, imágenes e historial de producto.',
  'planifica|segments':
    'Gestiona los segmentos de clientes y los productos infaltables asociados por atributo, usados en las estrategias comerciales.',
  'planifica|essentials': 'Gestiona productos infaltables asociados por cliente o segmento.',
  'planifica|price_lists': 'Listas de precios, detalles, clientes, productos, e historial.',
  'planifica|special_prices': 'Precios especiales, escalas y copias.',
  'planifica|promotions':
    'Listado, detalles, crear promociones, crear copias de promociones y suspender.',
  'planifica|route_plans': 'Planificación de rutas, visitas programadas y detalle de ejecución.',
  'planifica|pos_tasks': 'Listado, detalles, crear tareas, crear copias de tareas y suspender.',
  'planifica|users_app':
    'Listado, detalles, crear usuarios app, editar geocerca e historial.',
  'planifica|users.show.refund_limits_tab':
    'Habilita el máximo de devoluciones por usuario.',
  'planifica|poc_store_relations':
    'Asignación de relaciones entre tiendas, clientes y usuarios.',
  'planifica|add_deliveries_user': 'Asignación de usuarios responsables de entrega.',
  'ejecuta|poc_orders':
    'Listado, descargar listado, detalles, reprocesar, ver pedido, ver facturado y descargar OC.',
  'ejecuta|quotes': 'Listado y detalles de cotizaciones.',
  'ejecuta|orders': 'Listado y detalles de pedidos.',
  'ejecuta|refunds': 'Listado y detalles de devoluciones.',
  'ejecuta|refunds.show.refund_approval_rejected':
    'Habilita el flujo de conteo y aprobación de devoluciones.',
  'ejecuta|refunds.show.refund_process_code_erp':
    'Habilita el registro del NCR para completar el cierre de la devolución.',
  'ejecuta|deliveries': 'Listado y detalles de entregas.',
  'ejecuta|on_board_sales': 'Listado y detalles de las ventas a bordo.',
  'ejecuta|charges': 'Listado y detalles de cobros.',
  'ejecuta|pos_effectiveness':
    'Listado y descarga el detalle de actividades ejecutadas por los usuarios.',
  'ejecuta|reports_asset':
    'Consulta los reportes de activos entregados o retirados en punto de venta.',
  'ejecuta|close_asset': 'Habilita la consulta de los cierres de activos por cliente.',
  'ejecuta|settlements': 'Listado, detalles y descarga de liquidaciones.',
  'ejecuta|settlements.show.daily_control_tab':
    'Habilita la consulta del tab Control diario: estado de liquidación de los cobros de cada usuario por día, con montos y detalle por cobro.',
  'ejecuta|settlements.show.approval_tab':
    'Habilita la edición de los datos de depósito (banco, número, monto, fecha) y la aprobación final con envío al ERP.',
  'mide|poc_fill_rate':
    'Consulta el reporte de cumplimiento de órdenes vs. pedidos por cadena y el detalle de productos con diferencias. Ambos reportes se pueden descargar.',
  'mide|reports':
    'Consulta y descarga reportes por pedidos, devoluciones, cobros, entregas y ejecución en punto de venta.',
  'mide|reports.user_summary.timestamp_tab':
    'Habilita la consulta del tab de control de horario en el reporte por usuario.',
  'mide|pos_analysis_download':
    'Genera y descarga reportes configurables de ejecución, horario, tareas y usuarios.',
  'planifica|rbac.users': 'Listado, creación, edición, asignación de roles e historial.',
  'planifica|rbac.roles':
    'Listado, creación, edición, permisos, usuarios asociados e historial.'
}

export function scopeStateKey(moduleKey, scopeKey) {
  return `${moduleKey}|${scopeKey}`
}

export function scopeTitle(moduleKey, scope) {
  return SCOPE_LABEL_OVERRIDES[scopeStateKey(moduleKey, scope.key)] || scope.label
}

export function scopeDescription(moduleKey, scope) {
  return (
    SCOPE_DESCRIPTIONS[scopeStateKey(moduleKey, scope.key)] ||
    'Configura el nivel de acceso disponible para este módulo.'
  )
}

export const wizardFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '4px',
    bgcolor: UI_COLOR_WHITE,
    color: UI_COLOR_TEXT_WIZARD_FIELD,
    fontSize: 16,
    '& fieldset': { borderColor: UI_COLOR_BORDER_WIZARD_FIELD },
    '&:hover fieldset': { borderColor: UI_COLOR_BORDER_WIZARD_FIELD_HOVER },
    '&.Mui-focused fieldset': { borderColor: UI_COLOR_TEXT_MUTED_LIGHT, borderWidth: 1 }
  },
  '& .MuiOutlinedInput-input': { py: 1.05, px: 1.5 },
  '& .MuiInputBase-inputMultiline': { py: 1.2, px: 1.5 },
  '& .MuiOutlinedInput-input::placeholder': { color: UI_COLOR_TEXT_WIZARD_PLACEHOLDER, opacity: 1 },
  '& .MuiFormHelperText-root': {
    mx: 0,
    mt: 0.5,
    textAlign: 'right',
    color: UI_COLOR_TEXT_WIZARD_HINT,
    fontSize: 13,
    lineHeight: 1.2
  },
  '& .MuiFormHelperText-root.Mui-error': {
    color: UI_COLOR_WIZARD_ERROR,
    textAlign: 'left'
  }
}

export const wizardLabelSx = {
  display: 'block',
  mb: 1,
  fontSize: 15,
  fontWeight: 500,
  lineHeight: 1.2
}

export const wizardRequiredMarkSx = {
  color: UI_COLOR_WIZARD_ERROR
}

export const wizardStepperSx = {
  '& .MuiStepConnector-line': {
    borderColor: UI_COLOR_STEPPER_MUTED
  },
  '& .MuiStepIcon-root': {
    color: UI_COLOR_STEPPER_MUTED,
    fontSize: 22
  },
  '& .MuiStepIcon-root.Mui-active, & .MuiStepIcon-root.Mui-completed': {
    color: 'var(--color-action-primary)'
  },
  '& .MuiStepIcon-text': {
    fill: UI_COLOR_WHITE,
    fontSize: 12,
    fontWeight: 500
  },
  '& .MuiStepLabel-label': {
    color: UI_COLOR_STEPPER_LABEL,
    fontSize: 14,
    fontWeight: 500
  },
  '& .MuiStepLabel-root': {
    gap: 0.35
  },
  '& .MuiStepLabel-label.Mui-active, & .MuiStepLabel-label.Mui-completed': {
    color: UI_COLOR_BLACK
  }
}

export const permissionScopeGridSx = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1fr) auto' },
  alignItems: 'center',
  gap: { xs: 1.5, md: 2 }
}

export const permissionSpecialScopeSx = {
  border: `1px solid ${UI_COLOR_BORDER_PERMISSION_ALT}`,
  borderRadius: '7px',
  bgcolor: UI_COLOR_SURFACE_PERMISSION_SOFT
}

export const permissionReadOnlySpecialScopeSx = {
  border: `1px solid ${UI_COLOR_BORDER_PERMISSION}`,
  borderRadius: '7px',
  backgroundColor: UI_COLOR_SURFACE_PERMISSION_SOFT
}

export const permissionScopeTitleSx = {
  color: UI_COLOR_TEXT_PERMISSION_TITLE,
  fontSize: 16,
  fontWeight: 900,
  lineHeight: 1.25
}

export const permissionScopeTitleCompactSx = {
  color: UI_COLOR_TEXT_PERMISSION_TITLE,
  fontSize: 15,
  fontWeight: 900,
  lineHeight: 1.25
}

export const permissionScopeDescriptionSx = {
  mt: 0.25,
  color: UI_COLOR_ICON_GRAY,
  fontSize: 15,
  lineHeight: 1.35
}

export const permissionScopeDescriptionCompactSx = {
  mt: 0.35,
  color: UI_COLOR_ICON_GRAY,
  fontSize: 13,
  lineHeight: 1.35
}

export const permissionGroupRowSx = {
  borderTop: `1px solid ${UI_COLOR_BORDER_PERMISSION_ROW}`,
  '&:first-of-type': { borderTop: 'none' }
}

export const permissionSpecialBadgeSx = {
  display: 'inline-flex',
  alignItems: 'center',
  height: 18,
  px: 1.1,
  mb: 1.1,
  borderRadius: 999,
  bgcolor: UI_COLOR_BADGE_SPECIAL_BG,
  backgroundColor: UI_COLOR_BADGE_SPECIAL_BG,
  color: UI_COLOR_BADGE_SPECIAL_TEXT,
  fontSize: 12,
  fontWeight: 900,
  textTransform: 'uppercase'
}

export const permissionModuleTitleSx = {
  color: UI_COLOR_TEXT_PRESET,
  fontSize: 18,
  fontWeight: 900,
  lineHeight: 1.2,
  textTransform: 'uppercase'
}

export const permissionModulePanelSx = {
  borderColor: UI_COLOR_BORDER_PERMISSION,
  borderRadius: '8px',
  overflow: 'hidden',
  boxShadow: UI_COLOR_SHADOW_PERMISSION_CONTROL
}

export const permissionGroupPanelSx = {
  border: `1px solid ${UI_COLOR_BORDER_PERMISSION}`,
  borderRadius: '8px',
  backgroundColor: UI_COLOR_WHITE,
  overflow: 'hidden'
}

export const permissionApplyAllBarSx = {
  borderColor: UI_COLOR_BORDER_SURVEY_INPUT,
  borderRadius: '8px',
  px: { xs: 2, md: 2.1 },
  py: 1.45,
  display: 'flex',
  alignItems: { xs: 'stretch', md: 'center' },
  gap: 1.5,
  flexDirection: { xs: 'column', md: 'row' }
}

export const permissionApplyAllLabelSx = {
  color: UI_COLOR_ICON_GRAY,
  fontSize: 14,
  fontWeight: 800
}

export const permissionEmptyStateSx = {
  p: 3,
  borderRadius: '8px',
  color: UI_COLOR_TEXT_CANCEL
}

export const RBAC_PERMISSION_HELP_ICON_COLOR = UI_COLOR_ICON_HELP
export const RBAC_PERMISSION_HELP_ACCENT_COLOR = UI_COLOR_ICON_HELP_ACCENT
